import { FunctionalityType } from "./FunctionalityType";
import type { FunctionalityTypeInformation } from "./FunctionalityTypeInformation";

export class FunctionalityTypeFunctions {
    public static functionalityTypeIcon: (functionalityType: FunctionalityType) => string = (
        functionalityType: FunctionalityType,
    ) => {
        switch (functionalityType) {
            case FunctionalityType.MotionDetection:
                return "ir-motion-detection";
            case FunctionalityType.Recording:
                return "ir-recording";
            case FunctionalityType.FlameDetection:
                return "ir-flame-detection";
            case FunctionalityType.Monitoring:
                return "plug";
            case FunctionalityType.Care:
                return "bed";
            default:
                return "file-text";
        }
    };

    public static enhanceInformation(
        functionalityTypeInformation: Pick<FunctionalityTypeInformation, "type" | "categoryName">,
    ) {
        return {
            ...functionalityTypeInformation,
            name: FunctionalityType[functionalityTypeInformation.type],
            icon: FunctionalityTypeFunctions.functionalityTypeIcon(functionalityTypeInformation.type),
        } as FunctionalityTypeInformation;
    }

    public static getTypesWithInformation(): FunctionalityTypeInformation[] {
        return [
            {
                categoryName: "Detection",
                type: FunctionalityType.MotionDetection,
            },
            {
                categoryName: "Detection",
                type: FunctionalityType.FlameDetection,
            },
            {
                categoryName: "Recording",
                type: FunctionalityType.Recording,
            },
        ].map((ft) => FunctionalityTypeFunctions.enhanceInformation(ft));
    }
}
